import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaTelegramPlane, FaWhatsapp } from "react-icons/fa";
import "./Navbar.css"; // Assuming you have a CSS file for styling
export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="container-pro-div">
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid d-flex align-items-center justify-content-between">
          <Link className="navbar-brand mb-0" to="/">
            ⚖️ GranitsaInfo
          </Link>

          <button
            className="burger-btn"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`line ${menuOpen ? "open" : ""}`}></span>
            <span className={`line ${menuOpen ? "open" : ""}`}></span>
            <span className={`line ${menuOpen ? "open" : ""}`}></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarText">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              {/* <li className="nav-item">
                <Link className="navbar-main" to="/main">
                  Въезд в РБ и РФ
                </Link>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <Link
          className="mobile-nav-link"
          to="/main"
          onClick={() => setMenuOpen(false)}
        >
          Въезд в РБ и РФ
        </Link>

        <div className="contact-us">
          <p>По всем вопросам:</p>
          <div className="contact-icons-mobile">
            <a
              href="https://t.me/Granitsainfo"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTelegramPlane className="telegram-icon-mobile" />
            </a>
            <a
              href="https://wa.me/34613150502"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp className="whatsapp-icon-mobile" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
